(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('timeRegisterNewJobConf', {
        templateUrl: 'views/components/views/trNewJobConf/trNewJobConf.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'trNewJobConfService', 'timeRegisterService', function ($stateParams, stateService, utilityService, translateService, modalService, trNewJobConfService, timeRegisterService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let labourNo = $stateParams.labour_no;
            let argType = $stateParams.argtype;
            let argValue = $stateParams.argvalue;

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                argtype: argType,
                offDutyCodeButtons: [
                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('offdutycode_keyno') }
                ],
                edit: {},
                selectListOffDutyCodes: [],
                itemsListExtraPowTimes: [],
                lockedSave: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE CALLS

            async function loadEdit() {
                vm.model.edit = (await trNewJobConfService.getEdit({
                    labour_no: labourNo,
                    argtype: argType,
                    argvalue: argValue
                }))[0];
            }

            async function loadSelectOffDutyCodes() {
                vm.model.selectListOffDutyCodes = await trNewJobConfService.listSelectOffDutyCodes();
            }

            async function retrieveOvertime() {
                if (utilityService.validateParmsValue(vm.model.edit.labour_no) !== true) return;
                if (utilityService.validateParmsValue(vm.model.edit.old_job_start) !== true) return;
                if (utilityService.validateParmsValue(vm.model.edit.timestamp_out_corrected) !== true) return;

                const response = (await trNewJobConfService.getOvertime({
                    labour_no: vm.model.edit.labour_no,
                    dt_start: vm.model.edit.old_job_start,
                    dt_end: vm.model.edit.timestamp_out_corrected
                }))[0];

                if (response?.overtime_hours !== '0.00') {
                    vm.model.edit.overtime_hours = response?.overtime_hours;
                }
            }

            async function loadExtraPowTimes() {
                return vm.model.itemsListExtraPowTimes = await timeRegisterService.listExtraPowTimes(vm.model.edit);
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region CHANGE FUNCTION

            function offDutyCodeChanged() {
                let i;

                for (i = 0; i < vm.model.selectListOffDutyCodes.length; i++) {
                    if (vm.model.selectListOffDutyCodes[i].item_id && vm.model.selectListOffDutyCodes[i].item_id !== '0') {
                        if (vm.model.edit.offdutycode_keyno === vm.model.selectListOffDutyCodes[i].item_id) {
                            vm.model.edit.offdutycode_specification_required = vm.model.selectListOffDutyCodes[i].note_required;
                            return;
                        }
                    } else {
                        vm.model.edit.offdutycode_specification_required = '0';
                    }
                }
            }

            // #endregion CHANGE FUNCTION

            // #region RESET BUTTON FUNCTION

            function clear(id) {
                switch (id) {
                    case 'offdutycode_keyno':
                        vm.model.edit.offdutycode_keyno = '0';

                        if (vm.model.edit.offdutycode_keyno === '0') offDutyCodeChanged();
                        break;
                    default:
                        break;
                }
            }

            // #endregion RESET BUTTON FUNCTION

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                let mergeObj = {};
                mergeObj = angular.copy(vm.model.edit);
                mergeObj.powtimeextras = vm.model.itemsListExtraPowTimes;

                trNewJobConfService.saveObj(mergeObj).then(function (response) {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.lockedSave = false;
                                }
                            }]
                        });
                    } else {
                        stateService.back('/' + 'trstart');
                        vm.model.lockedSave = false;
                    }
                });
            }

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region CANCEL BUTTON FUNCTION

            vm.cancelToTrStart = function () {
                stateService.back();
            }

            // #endregion CANCEL BUTTON FUNCTION

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'timestamp_out_corrected':
                        if (utilityService.validateWatchValue(value, vm.model.edit.timestamp_out_corrected) !== true) return;

                        vm.model.edit.timestamp_out_corrected = value;

                        if (utilityService.validateParmsValue(vm.model.edit.timestamp_out_corrected) !== true) return;

                        if (vm.model.edit.stamped === '1') retrieveOvertime();
                        break;
                    case 'offdutycode_keyno':
                        if (utilityService.validateWatchValue(value, vm.model.edit.offdutycode_keyno) !== true) return;

                        vm.model.edit.offdutycode_keyno = value;

                        if (utilityService.validateParmsValue(vm.model.edit.offdutycode_keyno) !== true) return;

                        if (vm.model.edit.offdutycode_keyno !== '0') offDutyCodeChanged();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                await loadEdit();
                loadSelectOffDutyCodes();
                loadExtraPowTimes();

                if (vm.model.edit.missingexit === '1') vm.model.edit.overtime_hours = '0.00';
                if (vm.model.edit.stamped === '1') retrieveOvertime();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
